export enum KeyCodeEnum {
  Comma = 188,
  Enter = 13,
  Semicolon = 186,
  Space = 32,
}
